import { Image } from '@outdoor-voices/ui';
import { memo } from 'react';
import PropTypes from 'prop-types';
import { OV_EMS_CDN } from '../../config/theme';
import css from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EarnRewards = /*#__PURE__*/memo(function (_ref) {
  var price = _ref.price;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: css.star,
      role: "presentation",
      children: /*#__PURE__*/_jsx(Image, {
        alt: "A Star",
        height: 326,
        sizes: [24],
        src: "".concat(OV_EMS_CDN, "loyalty/icons/star.png"),
        width: 324,
        wrap: false
      })
    }), /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: "Earn up to ".concat(Math.floor(price), " points with OV Rewards.")
      }
    })]
  });
});
EarnRewards.propTypes = {
  price: PropTypes.number
};